import React from 'react';
import PropTypes from 'prop-types';
import QuestionText from './QuestionText';
import MultipleChoiceOptions from './MultipleChoiceOptions';

const MultipleChoiceQuestion = ({question, item, data, answerOptions, handleAnswer}) => {
  const selectedValue = item in data ? data[item] : '';
  return (
    <React.Fragment>
      <QuestionText>
        {question}
      </QuestionText>
      <MultipleChoiceOptions
        item={item}
        options={answerOptions}
        handleAnswer={handleAnswer}
        selectedValue={selectedValue}
      />
    </React.Fragment>
  );
};

MultipleChoiceQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  item: PropTypes.string.isRequired,
  data: PropTypes.object,
  answerOptions: PropTypes.array.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default MultipleChoiceQuestion;
